import React from 'react';
import { cn } from '../../lib/utils';

export function Card({ className, children, hover = true, ...props }) {
  return (
    <div
      className={cn(
        'bg-slate-900/50 border border-slate-800 backdrop-blur-sm p-6 md:p-8 rounded-2xl relative overflow-hidden',
        hover && 'hover:border-primary/50 transition-all duration-300 hover:-translate-y-1',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHighlight({ className, children, ...props }) {
  return (
    <div
      className={cn(
        'bg-slate-900 border-2 border-primary relative overflow-visible shadow-2xl shadow-primary/20 rounded-3xl p-6 md:p-8',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
